// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c85458f","453":"8dd2e817","455":"09189a06","704":"00d9133e","977":"b9f0e41f"}[chunkId] + ".chunk.js";
};